/*
    @file:
        fullpage.js

    @description:
        Core Javascript file that handles
        home page section scrolling
*/

// Variables
var $                   = require( 'jquery' );
var jQuery              = require( 'jquery' );

var scrollOverflow      = require('../vendor/scrollOverflow');
var fullpage            = require('fullpage.js');


// Events
$(document).ready(function () {
    new fullpage('#fullpage', {
        licenseKey: '',
        anchors: ['home', 'vision', 'logineko', 'projects', 'info'],
        menu: '#fullpage-menu',
        responsiveSlides: true,
        scrollOverflow: true,
        touchSensitivity: 20,
        responsiveWidth: 800,
    });

    $(document).on('click', '.next-slide button', function(){
        fullpage_api.moveTo('vision');
    });

    if($(window).width() < 768) {
        $('#fullpage .section').each(function() {
            var imgSrc = $(this).find('.background .mobile').attr('src');
            // console.log(imgSrc);
            if(imgSrc !== undefined) {
                $(this).css('background-image', 'url('+ imgSrc + ')');
            }
        });
    }
});